import { IAddress } from '@/types/services'

interface IUserInput {
  address?: IAddress
  property_type: string
  property_usage?: string
  estimated_value?: number
  estimated_debt?: number
  use_of_proceeds: string[]
  email: string
  phone: string
  first_name: string
  last_name: string
  estimated_fico?: string
  consent_to_privacy: boolean
  consent_to_terms: boolean
  manually_created?: boolean
}

interface IRequestedOffer {
  ctv: number
  exchange_rate: number
  offer_investment: number
  offer_investment_percentage: number
  terms: number
  tltv: number
  total_home_finance: number
  total_home_finance_cap: number
  unlock_share: number
  pricing_version?: number
}
interface ICreateApplicationPayload {
  is_new_user: boolean
  email: string
  property: {
    address: IAddress
    estimated_value?: number
    estimated_debt: number
    property_type: string
    property_usage?: string
  }
  use_of_proceeds?: string[]
  manually_created?: boolean
}
export function getCreateApplicationPayload(
  userInput: IUserInput,
  isNewUser: boolean
): ICreateApplicationPayload {
  const {
    address,
    email,
    estimated_debt,
    property_type,
    use_of_proceeds,
    manually_created,
    property_usage,
  } = userInput

  return {
    is_new_user: isNewUser,
    email,
    property: {
      address: { ...address },
      estimated_debt,
      property_type,
      property_usage,
    },
    use_of_proceeds,
    manually_created,
  }
}
